import { signal, computed, batch } from '@preact/signals';

import type {
  KycLoadDataType,
  SettlementLoadDataType,
  CompletenesResponseDataType,
  ModalConfig,
  AccountLoadDataType,
} from 'src/types/types';

const _showSpinner = signal(false);
const _showModal = signal(false);

const _showModalHasFooter = signal(true);

const _showIziToast = signal(false);
const _showIziToastTitle = signal('');
const _showIziToastMessage = signal('');
const _showIziToastContext = signal('');
const _showSwal = signal(false);
const _showConfirmButton = signal(false);
const _swalAllowOutsideClick = signal(false);
const _showSwalTitle = signal('');
const _showSwalMessage = signal('');
const _showSwalContext = signal('');
const _showSwalType = signal('regular');
const _showSwalHtml = signal('');
const _showSwalTimer = signal(0);
const _showSwalTimerProgressBar = signal(false);

const deviceType = signal(null);
const device = signal(null);
const kycLoad = signal<KycLoadDataType>({} as KycLoadDataType);
const accountLoad = signal<AccountLoadDataType>({} as AccountLoadDataType);
const settlementLoad = signal<SettlementLoadDataType>(
  {} as SettlementLoadDataType
);
const completeness = signal<CompletenesResponseDataType>(
  {} as CompletenesResponseDataType
);

type SwalConfig = {
  title?: string;
  message?: string;
  context?: string;
  type?: string;
  html?: string;
  timer?: number;
  timerProgressBar?: boolean;
  allowOutsideClick?: boolean;
  showConfirmButton?: boolean;
};

const _modal = signal([{}]);
const _currentPage = signal(null);

export const GlobalState = {
  currentPage: _currentPage,
  modal: _modal,
  kycLoad,
  accountLoad,
  settlementLoad,
  completeness,
  deviceType,
  device,
  showSpinner: _showSpinner,
  showModal: _showModal,
  showIziToast: _showIziToast,
  showSwal: _showSwal,
  iziToastConfig: {
    title: _showIziToastTitle,
    context: _showIziToastContext,
    message: _showIziToastMessage,
    hasFooter: _showModalHasFooter,
  },

  swalConfig: {
    title: _showSwalTitle,
    message: _showSwalMessage,
    context: _showSwalContext,
    type: _showSwalType,
    html: _showSwalHtml,
    timer: _showSwalTimer,
    timerProgressBar: _showSwalTimerProgressBar,
    showConfirmButton: _showConfirmButton,
    allowOutsideClick: _swalAllowOutsideClick,
  },
  set: {
    showSpinner: (value, timeout?) => {
      if (!isNaN(timeout)) {
        setTimeout(() => {
          _showSpinner.value = value;
        }, timeout);
        return;
      }
      return (_showSpinner.value = value);
    },
    showModal: (value, config = {}) => {
      batch(() => {
        _showModal.value = value;
        _modal.value = [config];
      });
    },
    showIziToast: ({ title, message, context }) => {
      return batch(() => {
        _showIziToast.value = true;
        title != undefined && (_showIziToastTitle.value = title);
        message != undefined && (_showIziToastMessage.value = message);
        context != undefined && (_showIziToastContext.value = context);
      });
    },
    showSwal: ({
      title,
      message,
      context,
      type,
      timer,
      html,
      timerProgressBar,
      allowOutsideClick,
      showConfirmButton,
    }: SwalConfig) => {
      console.trace();
      return batch(() => {
        _showSwal.value = true;
        title != undefined && (_showSwalTitle.value = title);
        message != undefined && (_showSwalMessage.value = message);
        context != undefined && (_showSwalContext.value = context);
        type != undefined && (_showSwalType.value = type);
        timer != undefined && (_showSwalTimer.value = timer);
        html != undefined && (_showSwalHtml.value = html);
        timerProgressBar != undefined &&
          (_showSwalTimerProgressBar.value = timerProgressBar);

        allowOutsideClick != undefined &&
          (_swalAllowOutsideClick.value = allowOutsideClick);

        showConfirmButton != undefined &&
          (_showConfirmButton.value = showConfirmButton);
      });
    },
  },
  account: {
    isLogIn: signal(false),
  },
};
